var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNigeriaNaijaMegaJackpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nigeria_naija_mega_jackpot_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 259 196",
    style: {
      enableBackground: "new 0 0 259 196"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nigeria_naija_mega_jackpot_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.29,
    y1: 93.548,
    x2: 36.663,
    y2: 91.903
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#8f6126"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    style: {
      stopColor: "#180b0c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.86 73.33v75.73s7.64.17 10.11 10.76c0 0 67.64-29.69 160.23 0 0 0 1.25-6.49 10.29-11.44V73.33s-5.79-.67-8.94-9.66l-29.22 6.74s-5.84-45.44-53.94-45.44c0 0-43.15.49-50.11 45.44L53.1 63.45s-3.37 8.31-11.24 9.88z",
    style: {
      fill: "url(#nigeria_naija_mega_jackpot_SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06 81.42c0-29.66 19.53-46.48 43.43-46.48s43.27 18.5 43.27 45.64l31.96-7.08s2.36 4.89 6.74 6.24v63.04s-5.22 1.69-6.74 5.73c0 0-66.41-25.45-150.85 0 0 0-2.36-4.21-6.91-5.56V78.9s3.88-.51 6.4-5.06l32.7 7.58z",
    style: {
      fill: "#f68e1e"
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nigeria_naija_mega_jackpot_SVGID_00000036228015690532016940000008116532113128589741_",
    d: "M89.06 81.42c0-29.66 19.53-46.48 43.43-46.48s43.27 18.5 43.27 45.64l31.96-7.08s2.36 4.89 6.74 6.24v63.04s-5.22 1.69-6.74 5.73c0 0-66.41-25.45-150.85 0 0 0-2.36-4.21-6.91-5.56V78.9s3.88-.51 6.4-5.06l32.7 7.58z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "nigeria_naija_mega_jackpot_SVGID_00000182493985443766619870000003808253818996959361_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nigeria_naija_mega_jackpot_SVGID_00000036228015690532016940000008116532113128589741_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#nigeria_naija_mega_jackpot_SVGID_00000182493985443766619870000003808253818996959361_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "nigeria_naija_mega_jackpot_SVGID_00000074438078853474908670000016901511874105736381_",
    cx: 132.136,
    cy: 110.688,
    r: 143.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    style: {
      stopColor: "#e27825",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    style: {
      stopColor: "#ca6d28"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#nigeria_naija_mega_jackpot_SVGID_00000074438078853474908670000016901511874105736381_)"
    },
    d: "M132.07 266.58c-1.94 0-3.92-.05-5.86-.16l5.69-152.85.18-2.4.33 2.89 11.57 151.87c-3.94.43-7.95.65-11.91.65zm-35.3-5.9a115.24 115.24 0 0 1-16.92-7.37l52.07-142.44-35.15 149.81zm76.44-2.19-41.03-147.71 57.62 139.39c-5.34 3.23-10.92 6.03-16.59 8.32zM54.14 235.06c-4.74-4.32-9.27-9.09-13.48-14.16l91.16-110.23.04-.04-.99 1.75-76.73 122.68zm160.6-4.55L133.1 111.92l-.8-1.27.56.56 94.79 104.4c-4 5.31-8.35 10.32-12.91 14.9zM22.17 192.78c-3.15-6.12-5.97-12.56-8.38-19.14l117.37-62.82.55-.26-109.54 82.22zm222.87-6.33L132.4 110.52l-.21-.03.19.21-.12-.09-.08-.12.04.1-.03-.02.03.03.12.25-.21-.3.01.14-.03-.12v-.05l-.03-.05v.01l-.03-.01v.01l-.01-.01-.04.03v-.03.04l-.02.09-.18.3.14-.33-.05.04.1-.13h-.02l.01-.03h-.02l-.02.04-.15.03.16-.07-.04-.01h.06l.03-.01h.03l.01-.01.01.01.01-.01v-.02l.01.01-.01-.01.03-.01v-.02l.01-.01.02.01h.01l.01-.01v.01l.01.01h.01l.02.03h.06-.02.02l.15.07-.06-.04.2.08-.08-.01 120.26 56.29c-2.18 6.74-4.75 13.35-7.67 19.65zM4.92 139.14c-1.09-7.05-1.78-14.27-2.06-21.45l128.7-7.23-1.88.54L4.92 139.14zm255.27-7.29-125.03-20.86-2.49-.55 128.74-.47v.41c0 7.16-.41 14.39-1.22 21.47zM132 110.98l.02-.37.02.18-.04.19zm.18-.01-.06-.27.01-.07.04.1.01.24zm-.52-.42.2-.11-.12.09-.08.02zm.27-.2-.15-.11.2.09-.05.02zm.23-.04h-.01l.02-.03-.03.01.05-.03.28-.15-.15.12-.14.04-.02.04zm-.09-.02-.01-.01v.01l-.02-.06v-.01l-.05-.18.05.11.03-.77.05.68-.04.17.05-.11v.05l-.04.08.01.03-.03.01zm-.38-.08L4.87 81.93c1.09-7.1 2.59-14.17 4.49-21.02l122.33 49.3zm.79-.01 120.11-56.58c2.17 6.73 3.97 13.7 5.35 20.73L132.48 110.2zm-.32-.1.01-.1.04-.09-.05.19zm.22-.04 95.1-105.15a155.79 155.79 0 0 1 11.13 16.88l-104.56 87.02-1.67 1.25zm-.71-.03-1.85-1.24L22.04 28.23c3.13-6.1 6.64-12 10.44-17.54l99.19 99.34zm.61-.15.54-1.47 56.75-137.98c5.33 3.2 10.53 6.88 15.46 10.95l-72.75 128.5zm-.47 0L53.94-14.13c4.74-4.34 9.77-8.32 14.96-11.83l62.14 133.98.77 1.86zm.12-.02-.08-.3-35.34-149.4c5.74-1.98 11.65-3.49 17.57-4.49l17.85 154.19zm.26-.13L143.7-45.21c5.95.64 11.9 1.8 17.71 3.43l-28.93 150.27-.29 1.24z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m110.39 98.55-.04-7.72-3.29 6.19h-2.25l-3.29-5.93v7.45h-4.65V81.61h5.06l4.08 6.02 3.52-6.02H115l.04 16.94h-4.65zm52.12-2.79h-6.29l-1.11 2.89h-5.68l7.24-16.56h5.49l7.24 16.56h-5.77l-1.12-2.89zm-1.54-4.03-1.61-4.16-1.61 4.16h3.22zm-19.28 1.16h3.15v1.59c-.69.28-1.35.4-2.03.4-2.39 0-3.95-1.66-3.95-4.14 0-2.56 1.56-4.14 4.02-4.14 1.47 0 2.67.62 3.71 1.82l3.57-3.15c-1.68-2.06-4.31-3.19-7.57-3.19-5.47 0-9.37 3.57-9.37 8.66s3.9 8.66 9.25 8.66c2.44 0 5.2-.73 7.22-2.11v-8.44h-8v4.04zm-63.8 26.32c.92-1.18 1.85-2.41 2.77-3.68.81 1.37 1.57 2.12 2.42 2.23 1.07.15 1.66-.64 1.67-2.27.03-4.23.07-8.46.1-12.7h5.08c-.02 4.27-.05 8.53-.07 12.8-.03 5.74-2.26 8.22-6.36 7.46-2.37-.42-4.35-1.81-5.61-3.84zm25.69 3.68c-1.95-.09-3.9-.19-5.85-.31-.35 1.36-.71 2.13-1.06 3.47-2.12-.4-3.27-.8-5.26-1.24 2.28-7.35 4.57-13.8 6.86-21.85 1.7-.09 3.41-.17 5.11-.26 2.2 8.03 4.44 17.01 6.65 25.47-1.8-.07-5.43-.96-5.43-.96-.34-1.45-.68-2.89-1.02-4.32zm-1.39-5.97c-.49-2.05-.97-4.08-1.46-6.09-.51 2.03-1.02 4.03-1.53 6.03l2.99.06zm6.67-1.01c.04-7.66 3.71-13.07 8.66-13.11 3.02 0 4.99 1.4 6.5 4.77-1.1 1.64-2.28 2.97-3.38 4.59-1.26-2.01-1.5-2.31-2.89-2.33-2.16-.03-3.63 2.42-3.64 6.31-.02 3.89 1.43 6.45 3.59 6.56 1.39.06 2.48-1 3.39-2.9 1.09 1.67 2.19 3.36 3.28 5.04-1.53 3.31-3.93 5.06-6.97 4.86-4.97-.35-8.58-6.14-8.54-13.79z",
    style: {
      fill: "#cb5b28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28 120.79c-.39.75-.78 1.51-1.17 2.26 0 2.22 0 4.43-.01 6.65-1.71-.02-3.43-.06-5.14-.12l.06-26.77h5.11c0 3.25-.01 6.5-.01 9.76 1.7-3.24 3.39-6.5 5.07-9.76h5.66c-2.05 3.93-4.1 7.89-6.16 11.84 2.17 5.02 4.34 10.02 6.52 14.97-2.02.06-4.03.09-6.05.1-1.3-2.98-2.59-5.95-3.88-8.93zm26.75-8.16c.03 5.96-2.69 9.94-7 10.16-.74.03-1.49.07-2.23.1.01 2.17.01 4.35.02 6.52-1.74.09-3.49-1.29-5.23-1.23-.02-8.92-.04-16.38-.06-25.3h7.42c4.3.01 7.05 3.79 7.08 9.75zm-5.25.16c-.01-1.91-.7-3.07-2.13-3.04l-1.9.03c.01 2.07.01 4.14.02 6.22.63-.02 1.27-.03 1.9-.05 1.44-.06 2.12-1.25 2.11-3.16z",
    style: {
      fill: "#cb5b28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.98 115.87c-.04-7.43 3.61-12.8 8.63-12.76 5.02.06 8.73 4.99 8.77 11.69.04 6.7-3.59 12.22-8.61 12.9-5.03.66-8.75-4.4-8.79-11.83zm12.16-.68c-.02-3.58-1.58-5.71-3.49-5.66-1.92.05-3.44 2.35-3.42 6.08.02 3.73 1.58 5.86 3.49 5.68 1.92-.18 3.44-2.52 3.42-6.1zm9.1-7.61c-1.5.06-3 .12-4.51.17l-.03-5.36 2.72-1.7c0 1.58 14.22 3.17 14.22 4.75-1.5.07-5.79 1.84-7.22 2.16.01 4.67.02 9.68.04 14.35-1.71.3-3.43 1.14-5.15 1.41-.02-4.88-.05-10.9-.07-15.78z",
    style: {
      fill: "#cb5b28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d0e0f"
    },
    d: "m177.24 107.58 2.78-1.66-4.6.11-2.69 1.72zm7.91-.85 4.5-1.28-4.5.13zm-22.44 3.52s3.71-4.21 6.07-.5c0 0 .08-3.77-3.63-3.82.01-.01-3.2.78-2.44 4.32zm-1.74 16.77 2.92-4.3 10.19-6.46s-1.19 6.17-5.94 10.15c0 0-3.35 2.55-7.17.61zm-17.63 2.48-1.53-2.05h5.31l.7 2.05zm4.46-6.61-.76-2.19 8.65-14.21c0-.01 5.93 16.42-7.89 16.4zm-.04-13.12-.84-2.02.42-1.02 4.66 1.35-1.08 3.17c-.01.01-.26-1.99-3.16-1.48zm-13.6 19.94v-2.14h6.07v2.04zm-3.88-8.92v-1.91l-1.11 2.04v1.85zm9.59-20.09v2.1l-5.71 10.79-.55-1.21zm-19.23 11.45-.83-1.46 3.33-4.77.88 1.65zm-2.59 17.56-2.08-2.1 7.07-4.83 1.34 2.05s-1.84 5.01-6.33 4.88zm-3.24-17.56-1.66-1.33.38-3.26 3.56-.69 2.36.69.36 3.12c0 .01-3.17-2.94-5 1.47zm-20.47 11.8 2.33 2.09-6.43-1.47-1.17-1.91zm1.12-3.53 2.27 2.15 4.02.32-.48-2.06zm6.8 4.65 2.33 2.14 5.43.96-2.42-2.25zm-3.65-10.38-.87-3.43.73-2.27 1.39 5.92zm2.43-14.13 2.33 2.14 2.77 10.44-3.45-6.41zm-13.34.14 2.23 2.1v11.98l-2.28-2.34zm-3.42 20.13 2.35 2.06s-2.95 1.1-5.88-.85c0 0-2.09-.82-5.09-4.93l8.62 3.72zm93.03 2.54 3.02-2.34 4.86-1.35-2.73 2.28zm-13.69-24.73 1.54-1.65h5.89l-1.66 1.65zm.52-4.49-1.63 1.61h-5.56l.8-1.61h6.93m-15.26 4.49 1.75-1.71h5.59l-1.66 1.71zm8.9-18.21-1.66 1.65-2.9 6.63 1.7-1.64zm1.9 9.36 1.43-2.22-.59-1.53-1.19 2.85zM150 83.25l.16 2.02-3.57 3.15-.23-1.94zm-8.31 7.61v2.03h3.15v-2.53zm-4.95 6.84 1.29-1.94 11.43-.44.24 1.98c-.01-.01-6.43 4.43-12.96.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb5b28"
    },
    d: "m130.96 80 .86 1.29v4.21l-.86-1.21zm-.54 6.15.86 1.29v4.02l-.86-1.27zm.85 6.2.86 1.29v4.64l-.91-1.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb5b28"
    },
    d: "M122.13 93.64v-2.18h9.15v-4.02h-9.15V85.5h9.69v-4.21H117.5v15.67l-.86.03.86 1.29h14.63v-4.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6d0e0f"
    },
    d: "M116.64 96.99h14.58l.91 1.29H117.5zm4.67-6.83.82 1.3h9.15l-.86-1.27zm0-5.95.82 1.29h9.69l-.8-1.32zM95.35 96.99l1.51 1.56h4.66l-1.51-1.56zm7.94-1.52 1.52 1.56h2.25l-1.43-1.56zm5.59 1.52 1.51 1.56h4.65l-1.49-1.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cb5b28"
    },
    d: "m115 81.61-1.51-1.56v4.13zm-14.59-1.56 1.51 1.56 2.18 3.23-1.91.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m108.88 96.99-.04-7.72-3.29 6.19h-2.25l-3.3-5.92v7.45h-4.65V80.05h5.06l4.08 6.02 3.52-6.02h5.49l.04 16.94h-4.66zm22.39-4.64v4.64h-14.63V80h14.32v4.21h-9.69v1.94h9.15v4.02h-9.15v2.18h10zm32.89 1.75h-6.29l-1.11 2.89h-5.68l7.24-16.56h5.49l7.24 16.56h-5.77l-1.12-2.89zm-1.54-4.02-1.61-4.16-1.61 4.16h3.22zm-21.09.78h3.15v1.59c-.69.28-1.35.4-2.03.4-2.39 0-3.95-1.66-3.95-4.14 0-2.56 1.56-4.14 4.02-4.14 1.47 0 2.67.62 3.71 1.82l3.57-3.15c-1.68-2.06-4.31-3.19-7.57-3.19-5.47 0-9.37 3.57-9.37 8.66s3.9 8.66 9.25 8.66c2.44 0 5.2-.73 7.22-2.11v-8.44h-8v4.04zM75.66 117.1c.92-1.18 1.85-2.41 2.77-3.68.81 1.37 1.57 2.12 2.42 2.23 1.07.15 1.66-.64 1.67-2.27.03-4.23.07-8.46.1-12.7h5.08c-.02 4.27-.05 8.53-.07 12.8-.03 5.74-2.26 8.22-6.36 7.46-2.38-.41-4.35-1.8-5.61-3.84zm25.59 3.64c-1.95-.09-3.9-.19-5.85-.31-.35 1.36-.71 2.13-1.06 3.47-1.76-.16-3.27-.8-5.26-1.24 2.28-7.35 4.57-13.8 6.86-21.85 1.7-.09 3.41-.17 5.11-.26 2.2 8.03 4.44 17.01 6.65 25.47-1.8-.07-5.43-.96-5.43-.96-.35-1.44-.68-2.88-1.02-4.32zm-1.39-5.96c-.49-2.05-.97-4.08-1.46-6.09-.51 2.03-1.02 4.03-1.53 6.03l2.99.06zm7.62-.98c.04-7.66 3.71-13.07 8.66-13.11 3.02 0 5.39 1.85 6.9 5.21-1.1 1.64-2.2 3.28-3.3 4.9-.9-1.94-1.98-3.06-3.36-3.08-2.16-.03-3.63 2.42-3.64 6.31-.02 3.89 1.43 6.45 3.59 6.56 1.39.06 2.48-1 3.39-2.9 1.09 1.67 2.19 3.36 3.28 5.04-1.53 3.31-3.93 5.06-6.97 4.86-4.98-.35-8.6-6.13-8.55-13.79zm22.82 4.88c-.39.75-.78 1.51-1.17 2.26 0 2.22 0 4.43-.01 6.65-1.71-.02-3.43-.06-5.14-.12l.06-26.77h5.11c0 3.25-.01 6.5-.01 9.76 1.7-3.24 3.39-6.5 5.07-9.76h5.66c-2.05 3.93-4.1 7.89-6.16 11.84 2.17 5.02 4.34 10.02 6.52 14.97-2.02.06-4.03.09-6.05.1-1.3-2.97-2.59-5.95-3.88-8.93zm25.89-8.22c.03 5.96-2.69 9.94-7 10.16-.74.03-1.49.07-2.23.1.01 2.17.01 4.35.02 6.52-1.74.09-3.48.17-5.23.23l-.06-26.76h7.42c4.3 0 7.05 3.78 7.08 9.75zm-5.25.15c-.01-1.91-.7-3.07-2.13-3.04l-1.9.03c.01 2.07.01 4.14.02 6.22.63-.02 1.27-.03 1.9-.05 1.44-.06 2.12-1.25 2.11-3.16zm6.16 2.84c-.04-7.43 3.61-12.8 8.63-12.76 5.02.06 8.73 4.99 8.77 11.69.04 6.7-3.59 12.22-8.61 12.9-5.03.66-8.75-4.4-8.79-11.83zm12.16-.68c-.02-3.58-1.58-5.71-3.49-5.66-1.92.05-3.44 2.35-3.42 6.08.02 3.73 1.58 5.86 3.49 5.68 1.91-.18 3.44-2.52 3.42-6.1zm10.7-6.89c-1.5.06-3 .12-4.51.17l-.03-5.36h14.22v4.75l-4.5.21c.01 4.67.03 9.35.04 14.02-1.71.3-3.43 1.14-5.15 1.41-.02-4.87-.04-10.32-.07-15.2z",
    style: {
      fill: "#f2efef"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M108.78 65.49h3.03l3.95 5.81v-5.81h3.06v10.5h-3.06l-3.93-5.77v5.77h-3.05v-10.5zm18.52 8.77h-3.68l-.51 1.73h-3.31l3.95-10.5h3.54l3.95 10.5h-3.4l-.54-1.73zm-.68-2.27-1.16-3.77-1.15 3.77h2.31zm5.47-6.5h3.25v10.5h-3.25v-10.5zm9.07 0h3.25v5.71c0 1.2-.11 2.11-.32 2.73-.21.63-.64 1.15-1.28 1.59-.64.43-1.46.65-2.47.65-1.06 0-1.88-.14-2.46-.43-.58-.29-1.03-.71-1.35-1.26-.32-.55-.51-1.23-.56-2.04l3.1-.42c0 .46.05.81.12 1.03s.21.41.39.54c.12.09.3.14.53.14.36 0 .63-.13.8-.4.17-.27.25-.72.25-1.36v-6.48zm10.9 8.77h-3.68l-.51 1.73h-3.31l3.95-10.5h3.54l3.95 10.5h-3.4l-.54-1.73zm-.67-2.27-1.16-3.77-1.15 3.77h2.31z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 132.19,
    cy: 50.21,
    r: 9.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.29,
    cy: 50.29,
    r: 6.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 132.19,
    cy: 50.21,
    r: 6.8,
    style: {
      fill: "#ffecbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.28 44.73a6.8 6.8 0 0 1 6.8 6.8c0 1.14-.29 2.22-.78 3.16 1.05-1.2 1.7-2.76 1.7-4.49a6.8 6.8 0 0 0-6.8-6.8c-2.61 0-4.88 1.48-6.02 3.64a6.738 6.738 0 0 1 5.1-2.31z",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19 57.33c-3.93 0-7.12-3.2-7.12-7.12 0-3.93 3.2-7.12 7.12-7.12 3.93 0 7.12 3.2 7.12 7.12.01 3.92-3.19 7.12-7.12 7.12zm0-13.6c-3.57 0-6.48 2.91-6.48 6.48 0 3.57 2.91 6.48 6.48 6.48 3.57 0 6.48-2.91 6.48-6.48 0-3.58-2.91-6.48-6.48-6.48z",
    style: {
      fill: "#b9823c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "m134.37 54.59-4.39-6.36v5.71h-.64v-7.77l4.39 6.35v-5.7h.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "M128.55 48.96h40v40h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "M128.55 50.55h6.71v.64h-6.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "m134.69 54.42-4.39-6.36v5.71h-.65V46l4.4 6.35v-5.7h.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "M128.86 48.79h6.71v.64h-6.71zm0 1.59h6.71v.64h-6.71z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 146.29,
    cy: 50.29,
    r: 4.37,
    style: {
      fill: "#ffecbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.71 46.77a4.374 4.374 0 0 1 3.87 6.4c.68-.77 1.09-1.78 1.09-2.88 0-2.41-1.96-4.37-4.37-4.37-1.68 0-3.13.95-3.86 2.34.79-.91 1.96-1.49 3.27-1.49z",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29 54.98a4.69 4.69 0 1 1 0-9.38 4.69 4.69 0 0 1 0 9.38zm0-8.73c-2.23 0-4.05 1.81-4.05 4.05s1.81 4.05 4.05 4.05 4.05-1.81 4.05-4.05-1.82-4.05-4.05-4.05z",
    style: {
      fill: "#b9823c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "m147.69 53.1-2.82-4.08v3.67h-.41V47.7l2.82 4.08v-3.66h.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "M143.95 49.49h4.31v.41h-4.31zm0 1.02h4.31v.41h-4.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "m147.9 52.99-2.82-4.08v3.67h-.42v-4.99l2.82 4.08v-3.66h.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "M144.15 49.38h4.31v.41h-4.31zm0 1.02h4.31v.41h-4.31z"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 117.47,
    cy: 50.29,
    r: 6.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 117.47,
    cy: 50.29,
    r: 4.37,
    style: {
      fill: "#ffecbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.88 46.77a4.374 4.374 0 0 1 3.87 6.4c.68-.77 1.09-1.78 1.09-2.88 0-2.41-1.96-4.37-4.37-4.37-1.68 0-3.13.95-3.86 2.34.8-.91 1.96-1.49 3.27-1.49z",
    style: {
      opacity: 0.8,
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.47 54.98a4.69 4.69 0 1 1 4.69-4.69c0 2.59-2.11 4.69-4.69 4.69zm0-8.73c-2.23 0-4.05 1.81-4.05 4.05s1.81 4.05 4.05 4.05 4.05-1.81 4.05-4.05-1.82-4.05-4.05-4.05z",
    style: {
      fill: "#b9823c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "m118.87 53.1-2.82-4.08v3.67h-.41V47.7l2.82 4.08v-3.66h.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#815221"
    },
    d: "M115.13 49.49h4.31v.41h-4.31zm0 1.02h4.31v.41h-4.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "m119.07 52.99-2.82-4.08v3.67h-.41v-4.99l2.82 4.08v-3.66h.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d39a46"
    },
    d: "M115.33 49.38h4.31v.41h-4.31zm0 1.02h4.31v.41h-4.31z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaNaijaMegaJackpot);
export default __webpack_public_path__ + "static/media/nigeria_naija_mega_jackpot.c22b5747f53478ff21590054b14ba9f0.svg";
export { ForwardRef as ReactComponent };